export default __webpack_public_path__ + "static/abbeyRoad-44ca3d19a8e41e4292adc5bb96aebd6e.svg";